<div class="header-container">
  <h1 class="h1Header">Reglas de Precios</h1>
</div>

<div class="pricing-rules-container">

  <div class="cards-container" *ngIf="pricingRules.length > 0; else noRules">
    <div *ngFor="let rule of pricingRules" class="card">
      <div class="card-header">
        <div class="card-icon">{{ getIcon(rule.category) }}</div>
        <span class="status-badge" [ngClass]="{'active': rule.isActive, 'inactive': !rule.isActive}">
          {{ rule.isActive ? 'ACTIVA' : 'INACTIVA' }}
        </span>
      </div>
      <div class="card-content">
        <h3 class="card-title">{{ getCategoryDescription(rule.category) }}</h3>
        <p class="card-service">{{ getServiceLabel(rule.service) }}</p>
        <p class="card-value">{{ formatValue(rule) }}</p>
      </div>
      <button type="button" class="edit-btn" (click)="onEdit(rule)">Editar</button>
    </div>
  </div>

  <ng-template #noRules>
    <div class="no-rules-message">
      <p>No se encontraron reglas de precios. Puede agregar nuevas reglas desde el panel de administración.</p>
    </div>
  </ng-template>

  <!-- Modal de edición -->
  <div class="modal-overlay" [ngClass]="{'active': isEditModalOpen}">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Editar Regla de Precio</h3>
        <button type="button" class="close-btn" (click)="closeEditModal()">&times;</button>
      </div>
      
      <form [formGroup]="editForm" (ngSubmit)="saveRule()" class="edit-form" novalidate>
                <div class="form-group">
          <label>Categoría</label>
          <p class="form-control-static" *ngIf="currentRule">{{ getCategoryDescription(currentRule.category) }}</p>
        </div>

        <div class="form-group">
          <label>Tipo de Regla</label>
          <p class="form-control-static" *ngIf="currentRule">{{ getRuleTypeName(currentRule.type) }}</p>
        </div>
        
        <div class="form-group">
          <label for="service">Servicio</label>
          <select id="service" formControlName="service" class="form-control">
            <option *ngFor="let option of serviceOptions" [ngValue]="option.value">{{ option.label }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="value">Valor</label>
          <input type="number" id="value" formControlName="value" class="form-control" min="0" step="0.01">
          <div *ngIf="editForm.get('value')?.invalid && editForm.get('value')?.touched" class="error-message">
            El valor es requerido y debe ser un número positivo.
          </div>
        </div>
        
        <div class="form-actions">
          <button type="button" class="cancel-btn" (click)="closeEditModal()">Cancelar</button>
          <button type="submit" class="save-btn" [disabled]="editForm.invalid">Guardar Cambios</button>
        </div>
      </form>
    </div>
  </div>
</div>
